Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};exports.default=



getMissingSecuredProductsByStore;var _SecuredProduct=require('../model/SecuredProduct');var _canvas=require('../selectors/canvas');var _types=require('./types');var exceptions=_interopRequireWildcard(_types);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function getMissingSecuredProductsByStore(session,storeId){
var store=session.Store.withId(storeId);
return store.securedProductIds.
orderBy('updatedAt','asc').
toRefArray().
filter(function(securedProduct){return securedProduct.category===_SecuredProduct.SecuredProductCategory.MISSING;}).
map(function(securedProduct){
var status={
type:securedProduct.category,
typeDisplay:exceptions.typeDisplay.MISSING_SECURED_PRODUCT};

securedProduct.manufacturerName=(0,_canvas.getManufacturerName)(securedProduct,session);
return _extends({},
securedProduct,{
status:status});

});
}